import { ADD_MSG, CLEAR_MSGS, REMOVE_MSG } from '../constants';

const uuidv1 = require('uuid/v1');


const insertMsg = msg => ({
    type: ADD_MSG,
    msg,
})

export const removeMsg = id => ({
    type: REMOVE_MSG,
    id,
});

export const clearMsgs = () => ({
    type: CLEAR_MSGS,
});

export const addMsg = msg => (dispatch) => {
    const id = uuidv1()
    const msgToDispatch = { ...msg, id };

    if (msg.type === 'msg') {
        setTimeout(() => {
            dispatch(removeMsg(id))
        }, 10000)
    }

    dispatch(insertMsg(msgToDispatch));
    return id;
};



